import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">{contactData.title}</h2>
          <p className="mt-2 text-sm text-foreground-500">{contactData.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
          <a
            href={`mailto:${contactData.email}`}
            className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-lg bg-background-100 hover:bg-background-200 transition-colors cursor-pointer"
          >
            <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
              <i className="ri-mail-line text-xl text-primary-500"></i>
            </div>
            <div className="text-center">
              <div className="text-sm font-semibold text-foreground-900 whitespace-nowrap">电子邮箱</div>
              <div className="mt-1 text-xs text-foreground-500">{contactData.email}</div>
            </div>
          </a>

          <a
            href="#contact"
            className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-lg bg-background-100 hover:bg-background-200 transition-colors cursor-pointer"
          >
            <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors">
              <i className="ri-wechat-line text-xl text-accent-500"></i>
            </div>
            <div className="text-center">
              <div className="text-sm font-semibold text-foreground-900 whitespace-nowrap">微信公众号</div>
              <div className="mt-1 text-xs text-foreground-500">搜索「{contactData.wechat}」</div>
            </div>
          </a>

          <a
            href={`https://wpa.qq.com/msgrd?v=3&uin=${contactData.qq}&site=qq&menu=yes`}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-lg bg-background-100 hover:bg-background-200 transition-colors cursor-pointer"
          >
            <div className="w-12 h-12 rounded-full bg-secondary-100 flex items-center justify-center group-hover:bg-secondary-200 transition-colors">
              <i className="ri-qq-line text-xl text-secondary-500"></i>
            </div>
            <div className="text-center">
              <div className="text-sm font-semibold text-foreground-900 whitespace-nowrap">QQ 客服</div>
              <div className="mt-1 text-xs text-foreground-500">QQ：{contactData.qq}</div>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}